import Intercept from "@observer/Intercept.js";
import API from "@api/index.js";
import { $util } from "@util/util.js";
import Constant from "@constant/index.js";
import Alert from "@util/alert.js";
import useDiscountDetailsStore from "@shared/store/useDiscountDetailsStore";
import { WEBSITE_TYPE } from "@shared/constants";

export default class PriceView {
    constructor(model) {
        this._el = null;
        this._model = model;

        this._model._view = this;

        this._totalPrefixEl = $('span.ptotalprefix');
        this._totalSuffixEl = $('span.ptotalsuffix');
        this._discountEl = $('span.pdiscount');
        this._checkEl = $("i[tag='isCheckedAll']");
        this._totalCheckedCountEl = $('span.ptotalcount');
        // 商品总数
        this._totalGoods = $('#container_ShippingAddress span[tag="totalGoods"]');
    }



    interceptList() {
        //_totalPrefix
        new Intercept().init(this._totalPrefixEl, this._model, "_totalPrefix");
        //_totalSuffix
        new Intercept().init(this._totalSuffixEl, this._model, "_totalSuffix");
        //_discount
        new Intercept().init(this._discountEl, this._model, "_discount");
        //checked
        new Intercept().init(this._checkEl, this._model, "checkedAll", 'ck');
        //total chekced items
        new Intercept().init(this._totalCheckedCountEl, this._model, "_totalCheckedCountStr");
        //商品总数
        new Intercept().init(this._totalGoods, this._model, "_totalCount");
    }

    checkLogin() {
        if (window.location.href.indexOf('localhost') != -1) {
            return;
        }
        if (this._model._totalCount <= 0) {
            $("div.unlogin_wrapper").hide();
        } else {
            if (!passport.isLogin()) {
                $("div.unlogin_wrapper").show();
            } else {
                $("div.unlogin_wrapper").hide();
            }
        }
    }

    checkCartEmpty() {
        if (this._model._totalCount <= 0) {
            $("div[tag='hasNoCount']").show();
            $("div[tag='hasCount']").hide();
            $("div.unlogin_wrapper").hide();
            if (!passport.isLogin()) {
                $("div.cart_empty .le_button_login").show();
                $("div.cart_empty .le_button_gohome").removeClass("le_btn_solid").addClass("le_btn_border");
            } else {
                $("div.cart_empty .le_button_login").hide();
                $("div.cart_empty .le_button_gohome").removeClass("le_btn_border").addClass("le_btn_solid");
            }
        } else {
            $("div[tag='hasNoCount']").hide();
            $("div[tag='hasCount']").show();
        }
    }

    render() {
        this._totalPrefixEl.text(this._model._totalPrefix);
        this._totalSuffixEl.text(this._model._totalSuffix);
        this._discountEl.html(this._model._discount);
        this._totalCheckedCountEl.text(this._model._totalCheckedCountStr);
        this._totalGoods.text(this._model._totalCount);
        this.interceptList();
        if (this._model.checkedAll) { // 全选
            this._checkEl.addClass("icon-checked");
        }
        if (this._model?.deliveryPriceInfo?.checkoutButtonType == 1) {
            $('#gocheckout').text('领券结算');
        } else {
            $('#gocheckout').text('去结算');
        }
        this.regEvent();
        this.checkLogin();
        this.checkCartEmpty();
    }

    regEvent() {
        let that = this;
        // 底部节省了xx钱
        if (this?._model?.isShowDiscountDetails) {
            $('.discounted_price_pc').show();
        } else {
            $('.discounted_price_pc').hide();
        }
        // 优惠明细按钮显隐 deliveryPriceInfo这个字段有值才显示优惠明细按钮
        if (this?._model?.deliveryPriceInfo?.preferentialPrice) {
            $('.disocunt_detail_text').show();
        } else {
            $('.disocunt_detail_text').hide();
        }
        if(window._shopId === WEBSITE_TYPE.lenovo) {
          // 如果节省了xx钱和优惠明细都不展示，则将上部设置成居中显示
          if(!this?._model?.isShowDiscountDetails && !this?._model?.deliveryPriceInfo?.preferentialPrice) {
              $('.sum_box').css('line-height', '50px');
          } else {
              $('.sum_box').css('line-height', '0');
          }
        }
        $(".le_button_gohome").off("click").on("click", function () {
            window.location.href = $util.getHomeUrl();
        })

        $(".le_button_login").off("click").on("click", function () {
            passport.show();
        })

        //去结算页
        $("#gocheckout").off("click").on("click", function () {
            $("#gocheckout").attr("disabled", "disabled");
            if (that._model._totalCheckedCount <= 0) {
                Alert.showConfirm({
                    type: "warning",
                    title: Constant.MSG.NOCHECKED,
                    confirmText: "知道了",
                    confirm: function () {

                    }
                })
                $("#gocheckout").attr("disabled", null);
                return;
            }
            $util.doLoginAction().then(() => {
                API.goCheckout({ terminal: _terminal }).then(x => {
                    // 跳转前清掉 disabled，避免 BFCache 还原后按钮被永久锁死
                    $("#gocheckout").attr("disabled", null);
                    window.location.href = $util.getCheckoutUrl();
                }).catch(err => {
                    //21063  否则只显示返回修改
                    if (err.code == "21063") {
                        Alert.showConfirm({
                            title: err.msg,
                            confirmText: "购买其他商品",
                            confirm: function () {
                                API.goCheckout({ terminal: _terminal, buyOther: true }).then(x => {
                                    // 跳转前清掉 disabled，避免 BFCache 还原后按钮被永久锁死
                                    $("#gocheckout").attr("disabled", null);
                                    window.location.href = $util.getCheckoutUrl(true);
                                }).catch(err => {
                                    Alert.showMessage("warning", err.msg);
                                    $("#gocheckout").attr("disabled", null);
                                })
                            },
                            cancelText: "返回修改",
                            cancel: function () {

                            }
                        })
                    } else if (err.code == "40051") {// 候补销售需要实名认证，跳转商详页
                        // 请进行实名认证+URL_START+href+URL_END => 请进行实名认证URL_STARThttps://baiud.comURL_END
                        const [msgTitle, startRight] = err?.msg?.split('URL_START');
                        const href = startRight?.split('URL_END')[0];

                        Alert.showConfirm({
                            title: msgTitle,
                            confirmText: "去认证",
                            confirm: function () { // 需要实名认证跳转到商详页
                                let toAuthUrl = '';
                                if ($util.isProductionEnv()) {
                                    toAuthUrl = `https://activity.lenovo.com.cn/consumption_coupon/authentication.html?ru=${encodeURIComponent(href)}`;
                                } else {
                                    toAuthUrl = `https://activity.lenovouat.com/consumption_coupon/authentication.html?ru=${encodeURIComponent(href)}`
                                };
                                window.location.href = toAuthUrl;
                            }
                        })
                    } else {
                        Alert.showMessage("warning", err.msg);
                    }
                    $("#gocheckout").attr("disabled", null);
                })
            }).catch(err => {
                $("#gocheckout").attr("disabled", null);
            })
        })

        // 批量激活状态 页脚
        $("div#cart_pc_wrapper").off("click", "li[tag='CheckedAll']").on("click", "li[tag='CheckedAll']", function () {
            that._model.batchSetActive().then(res => {

            }).catch(err => {
                Alert.showMessage("error", err);
            })
        })
        // 批量激活状态 页头
        $("div#cart_pc_wrapper").off("click", "div[tag='CheckedAll']").on("click", "div[tag='CheckedAll']", function () {
            that._model.batchSetActive().then(res => {

            }).catch(err => {
                Alert.showMessage("error", err);
            })
        })

        //删除全部
        $("#deleteAllbtn").off("click").on("click", function () {
            let checkedItems = $util.getAllItems(that._model._parent._group, true);
            if (checkedItems.length == 0) {
                Alert.showConfirm({
                    type: "warning",
                    title: Constant.MSG.CANNOT_BATCHR_REMOVE,
                    confirmText: "知道了",
                    confirm: function () { }
                })
                return;
            }
            Alert.showConfirm({
                title: "删除商品？",
                content: "您可以选择移入收藏夹、或删除商品",
                confirmText: "移入收藏夹",
                confirm: function () {
                    that._model.batchToFavorite(checkedItems).then(() => {
                        that.checkCartEmpty();
                        let packageItems = $util.getAllPackageItems(that._model._parent._group);
                        if (packageItems.length > 0) {
                            Alert.showTip(Constant.MSG.PACKAGE_NO_ADD_FAV);
                        }
                    }).catch(err => {
                        Alert.showTip(err);
                    })
                },
                cancelText: "删除",
                cancel: function () {
                    let checkedItems = $util.getAllItems(that._model._parent._group, true);
                    if (checkedItems.length == 0) {
                        Alert.showTip(Constant.MSG.CANNOT_BATCHR_REMOVE);
                        return;
                    }
                    that._model.batchRemove(checkedItems).then(() => {
                        that.checkCartEmpty();
                    }).catch(err => {
                        Alert.showTip(err);
                    })
                }
            })
        })

        //删除失效商品
        $("#deletefailurebtn").off("click").on("click", function () {
            let invalidItems = $util.getInvalidItems(that._model._parent._group);
            if (invalidItems.length == 0) {
                Alert.showTip(Constant.MSG.NO_INVALID_GOODS);
                return;
            }
            Alert.showConfirm({
                type: "warning",
                title: Constant.MSG.CONFIRM_REMOVE_INVALID_GOODS,
                confirmText: "确定",
                confirm: function () {
                    that._model.batchRemove(invalidItems, true).then(() => {
                        that.checkCartEmpty();
                    }).catch(err => {
                        Alert.showTip(err);
                    })
                },
                cancelText: "取消",
                cancel: function () { }
            })
        })

        //批量添加收藏夹
        $("#movetofavbtn").off("click").on("click", function () {
            let checkedItems = $util.getAllItemsNotPackcage(that._model._parent._group, true);
            if (checkedItems.length == 0) {
                Alert.showConfirm({
                    type: "warning",
                    title: Constant.MSG.CANNOT_BATCHR_ADD_FAV,
                    confirmText: "知道了",
                    confirm: function () { }
                })
                return;
            }
            Alert.showConfirm({
                title: `确认要将这${checkedItems.length}件商品移入收藏夹吗？`,
                confirmText: "确定",
                confirm: function () {
                    that._model.batchToFavorite(checkedItems).then(() => {
                        that.checkCartEmpty();
                        let packageItems = $util.getAllPackageItems(that._model._parent._group);
                        if (packageItems.length > 0) {
                            Alert.showTip(Constant.MSG.PACKAGE_NO_ADD_FAV);
                        }
                    }).catch(err => {
                        Alert.showTip(err);
                    })
                },
                cancelText: "取消",
                cancel: function () {

                }
            })
        })
        // 点击优惠明细唤起弹层
        $('.disocunt_detail_text').off('click').on('click', () => {
            useDiscountDetailsStore()?.toggle();
        })

    }
}